<template>
	<div class="newadministrator">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">创建新管理员</div>
					<div class="contentcard">
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">用户名</span>
							<a-input style="width: 250px;" v-model="admin_info.username" placeholder="请输入用户名" />
						</div>
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">密码</span>
							<a-input style="width: 250px;" type="password" v-model="admin_info.password" placeholder="请输入密码" />
						</div>
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">显示名</span>
							<a-input style="width: 250px;" v-model="admin_info.display_name" placeholder="请输入显示名" />
						</div>
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">手机号码</span>
							<a-input style="width: 250px;" v-model="admin_info.phone_number" placeholder="请输入手机号码" />
						</div>
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">手机验证</span>
							<a-switch v-model="admin_info.phone_verified" :disabled="!admin_info.phone_number" checkedChildren="是"
							 unCheckedChildren="否" />
						</div>
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">Email</span>
							<a-input style="width: 250px;" v-model="admin_info.email" placeholder="请输入Email地址" />
						</div>
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">Email验证</span>
							<a-switch v-model="admin_info.email_verified" :disabled="!admin_info.email" checkedChildren="是"
							 unCheckedChildren="否" />
						</div>
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">是否激活</span>
							<a-switch v-model="admin_info.is_active" checkedChildren="是" unCheckedChildren="否" />
						</div>
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">是否雇员</span>
							<a-switch v-model="admin_info.is_staff" checkedChildren="是" unCheckedChildren="否" />
						</div>
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">权限组设置</span>
							<a-select placeholder="请选择" style="width: 250px" v-model="admin_info.permission_group_id" @change="(value)=>{admin_info.permission_group_id = value}">
								<a-select-option :value="item.id" v-for="item in permission_group" :key="item">{{item.permission_group_name}}</a-select-option>
							</a-select>
						</div>
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">是否CMS管理员</span>
							<a-switch v-model="admin_info.is_cms" checkedChildren="是" unCheckedChildren="否" />
						</div>
						<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">是否超级管理员</span>
							<a-switch v-model="admin_info.is_super" checkedChildren="是" unCheckedChildren="否" />
						</div>
						<div style="text-align: center;">
							<a-button type="primary" size="small" style="width: 96px;font-size: 12px;" @click="newadmin">确定</a-button>

						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>

	</div>
</template>

<script>
	import CryptoJS from 'crypto-js';

	export default {

		data() {
			return {
				current: ['newadministrator'],
				openKeys: ['usermanagement'],
				newpermissionname: null,
				permission_list: [],
				permission_group: [],
				select_group: null,
				permissionsdef: [],
				permissions: 0,
				admin_info: {},
			}
		},
		created: function() {
			var self = this;
			this.$axios.get('/permission/newadministrator').then(function(res) {
				self.permission_list = res.data.permission_list;
				self.permission_group = res.data.permission_group;

			});
		},
		methods: {
			newadmin() {
				if (!this.admin_info.username) {
					return this.$message.error('用户名不能为空');
				}
				if (!this.admin_info.password) {
					return this.$message.error('密码不能为空');
				}
				if (!this.admin_info.display_name) {
					return this.$message.error('显示名不能为空');
				}
				if (!this.admin_info.permission_group_id) {
					return this.$message.error('权限组不能为空');
				}
				var temp = {}
				temp.username = this.admin_info.username || null;
				temp.display_name = this.admin_info.display_name || null;
				temp.password = this.admin_info.password || null;
				temp.password = CryptoJS.MD5(temp.password).toString(CryptoJS.enc.Hex);
				temp.phone_number = this.admin_info.phone_number || null;
				temp.phone_verified = this.admin_info.phone_verified || false;
				temp.email = this.admin_info.email || null;
				temp.email_verified = this.admin_info.email_verified || false;
				temp.is_active = this.admin_info.is_active || false;
				temp.is_staff = this.admin_info.is_staff || false;
				temp.is_super = this.admin_info.is_super || false;
				temp.is_member = this.admin_info.is_member || false;
				temp.is_cms = this.admin_info.is_cms || false;
				temp.permission_group_id = this.admin_info.permission_group_id || null;
				temp.sex = this.admin_info.sex || 0;
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否新增管理员',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/permission/newadministrator/created', {
							params: {
								admin_info: temp
							}
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.admin_info = {};
						});
					},
					onCancel() {},
				});
			},

		},

	};
</script>

<style>

	.newadministrator .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// index.vue?b49f6e36